import React from 'react';
import { useIntl } from 'react-intl';

type Props = {
    indeterminate?: boolean;
};

const TableCheckBox: React.ForwardRefRenderFunction<HTMLInputElement, Props> = ({ indeterminate = false, ...rest }, ref) => {
    const intl = useIntl();

    const defaultRef = React.useRef<HTMLInputElement>();
    const resolvedRef = (ref || defaultRef) as React.MutableRefObject<HTMLInputElement>;

    React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <div className="form-check">
        <input aria-label={ intl.formatMessage({ id: 'checkbox.select' })} className="form-check-input" type="checkbox" name="selectrow" id={"selectrow"} 
               ref={resolvedRef} 
               {...rest}
               />
      </div>
    );
};

export default React.forwardRef(TableCheckBox);